import { PossibleBusinessObject, IPath, CommonBusinessObject } from '@iotv/iotv-v3-types'
import { Geofence } from './Geofence'
import { GeofencePointsType, UserAttributeDefs } from '../../types/ModelTypes'
import { IGeofence } from '../../ModelClassInterfaces/Geo'
import { GeoLine } from './GeoLine'

const debug = process.env.REACT_APP_DEBUG && false

const typeName = 'Path'

export class Path extends GeoLine implements IPath {
  constructor(ob: IPath & CommonBusinessObject & Partial<IGeofence>) {
    super({ ...ob, type: ob.type ?? typeName })
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: { type: 'String', editable: true, label: 'Name', name: 'name', description: 'identification' },
      description: { type: 'String', editable: true, label: 'Description', description: 'description' },
    }
  }
}
